import { render, staticRenderFns } from "./TabsPlaylists.vue?vue&type=template&id=1c1de59d"
import script from "./TabsPlaylists.vue?vue&type=script&lang=js"
export * from "./TabsPlaylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports